import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const UnauthenticatedRoutes = () => {
  const loggedIn = useSelector((state) => state.user.loggedIn);

  return loggedIn ? <Navigate to="/" /> : <Outlet />;
};

export default UnauthenticatedRoutes;
